/* @noflow */
/* eslint-disable global-require, consistent-return */
/* global __PROD__ */

/**
 * Conditionally load polyfills for older browsers
 * while utilizing modern browser functionality.
 * https://hackernoon.com/polyfills-everything-you-ever-wanted-to-know-or-maybe-a-bit-less-7c8de164e423
 */

/**
 * This load point is injected into the CRA pipeline via config-override.js
 * index.js should be considered the application entry point for all modern browsers
 * since the polyfills are skipped there.
 */

import '../node_modules/bootstrap/dist/css/bootstrap.css';
import './index.css';
import polyfill from './polyfill';

if (__PROD__) {
  require('./utils/rollbar');
}

try {
  polyfill().then(() => {
    require('./main'); // eslint-disable-line global-require
  });
} catch (err) {
  console.error('Error loading polyfills: ', err); // eslint-disable-line no-console
}



// WEBPACK FOOTER //
// ./src/index.js